module.exports = __webpack_public_path__ + "img/news.20a8e95a.jpg";